import {impersonateTypes} from "./impersonate.types";

const IMPERSONATE_INITIAL_STATE = {
    impersonateUserList: [],
};


const impersonateUser = (state = IMPERSONATE_INITIAL_STATE, action) => {
    switch (action.type) {
        case impersonateTypes.GET_ALL_IMPERSONATE_USERS:
            if (action.payload) {
                return {
                    ...state,
                    impersonateUserList: action.payload,
                };
            } else {
                return {
                    ...state
                }
            }

        default:
            return state;
    }
}

export default impersonateUser;
